import template from './contactsSimpleEdit.template.html';

export default {
  template,
  bindings: {
    contact: '=',
    ticketContacts: '<',
    ticketContactLabels: '<',
    idTicketOwner: '<',
    workflow: '<',
    formName: '<',
    countries: '<',
    options: '<',
    isDisabled: '<',
    hasAssetFinanceTools: '<',
    onDeleted: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $mdMedia,
      $mdUtil,
      $timeout,
      Contact,
      contactService,
      contactsService,
      helperService,
      searchService,
      CONTACT,
      uiService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.contacts = [];
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.organizationCountry = '';
      ctrl.emailValidationMessage = '';
      ctrl.temporaryHidden = true;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.contact = ctrl.contact || {};
        ctrl.ticketContacts = ctrl.ticketContacts || [];
        ctrl.ticketContactLabels = ctrl.ticketContactLabels || [];
        ctrl.idTicketOwner = ctrl.idTicketOwner || '';
        ctrl.workflow = ctrl.workflow || {};
        ctrl.countries = ctrl.countries || [];
        ctrl.options = ctrl.options || {};
        ctrl.isDisabled = ctrl.isDisabled || false;
        ctrl.hasAssetFinanceTools = ctrl.hasAssetFinanceTools || false;
      };

      ctrl.contactDelete = ($event, contactToDelete) => {
        ctrl.onDeleted({ event: $event, contact: contactToDelete });
      };

      ctrl.updateContact = _.debounce((contactToUpdate) => {
        const simpleContact = contactToUpdate;
        if (!_.isString(simpleContact?.name)) {
          simpleContact.name = simpleContact?.name?.name || '';
        }
        if (ctrl.searchText && _.isString(ctrl.searchText) && !simpleContact?.name) {
          simpleContact.name = ctrl.searchText;
        }
        let isContactReady = false;
        if (
          simpleContact?.isCompany &&
          _.isString(simpleContact?.name) &&
          simpleContact?.name !== ''
        ) {
          isContactReady = true;
        } else if (
          !simpleContact?.isCompany &&
          _.isString(simpleContact?.name) &&
          simpleContact?.name !== '' &&
          simpleContact?.familyName !== ''
        ) {
          isContactReady = true;
        }

        if (isContactReady) {
          contactsService.clearCache();
          let contact = null;

          if (!simpleContact.id) {
            contact = Contact.blank();
            if (ctrl.idTicketOwner && ctrl.idTicketOwner !== '') {
              contact.idOwner = ctrl.idTicketOwner;
            }
            contact = ctrl.fillContactFields(contact, simpleContact);

            contactService.createContact(contact).then((data) => {
              if (data.status) {
                simpleContact.id = data.id;
                simpleContact.name = ctrl.searchText;
                ctrl.onFinished({ contact: simpleContact });
              }
            });
          } else {
            contactService.readContact({ id: simpleContact.id }).then((data) => {
              contact = ctrl.fillContactFields(data, simpleContact);
              contactService.updateContact(contact).then(() => {
                contactsService.clearCache();
              });
              ctrl.onFinished({ contact: simpleContact });
            });
          }
        }
      }, 2000);

      ctrl.fillContactFields = (selectedContact, simpleContact) => {
        const contact = selectedContact;
        contact.id = simpleContact.id;
        contact.isCompany = simpleContact.isCompany;
        if (contact.idLabels.indexOf(simpleContact.type) === -1) {
          contact.idLabels.push(simpleContact.type);
        }
        if (contact.isCompany) {
          contact.company.information.name = simpleContact.name || ctrl.searchText;
          contact.company.contact.phoneCode = simpleContact.phoneCode;
          contact.company.contact.phone = simpleContact.phone;
          contact.company.contact.email = simpleContact.email;
          contact.person.contact.homeCode = '';
          contact.person.contact.home = '';
          contact.person.contact.workCode = '';
          contact.person.contact.work = '';
          contact.person.contact.preferredContactMethod.phone =
            simpleContact.preferredContactMethod?.phone || '';
          contact.person.contact.preferredContactMethod.email =
            simpleContact.preferredContactMethod?.email || '';
          contact.person.contact.housing = '';
          if (contact.person.employments.length) {
            contact.person.employments[0].type = '';
            contact.person.employments[0].basis = '';
            contact.person.employments[0].subTypes.onBenefits = false;
            contact.person.employments[0].subTypes.student = false;
            contact.person.employments[0].subTypes.homeDuties = false;
          }
        } else {
          contact.person.information.firstName = simpleContact.name || ctrl.searchText;
          contact.person.information.familyName = simpleContact.familyName;
          contact.person.contact.primaryCode = simpleContact.phoneCode;
          contact.person.contact.primary = simpleContact.phone;
          contact.person.contact.email = simpleContact.email;
          contact.person.contact.homeCode = simpleContact.homeCode;
          contact.person.contact.home = simpleContact.home;
          contact.person.contact.workCode = simpleContact.workCode;
          contact.person.contact.work = simpleContact.work;
          contact.person.contact.preferredContactMethod.phone =
            simpleContact.preferredContactMethod?.phone || '';
          contact.person.contact.preferredContactMethod.email =
            simpleContact.preferredContactMethod?.email || '';
          if (ctrl.workflow.isAssetFinance()) {
            contact.person.contact.housing = simpleContact.residentialStatus;
            if (contact.person.employments.length) {
              contact.person.employments[0].type = simpleContact.employmentType;
              contact.person.employments[0].basis = simpleContact.employmentBasis;
              contact.person.employments[0].subTypes.onBenefits =
                simpleContact.employmentSubTypes.onBenefits;
              contact.person.employments[0].subTypes.student =
                simpleContact.employmentSubTypes.student;
              contact.person.employments[0].subTypes.homeDuties =
                simpleContact.employmentSubTypes.homeDuties;
            }
          }
        }

        return contact;
      };

      ctrl.selectedItemChange = (selectedContact) => {
        if (selectedContact && selectedContact.id) {
          contactService.readContact({ id: selectedContact.id }).then((data) => {
            const contact = data;
            if (contact) {
              const contactExist = _.find(ctrl.ticketContacts, { id: contact.id });
              if (!contactExist) {
                ctrl.contact.id = contact.id;
                ctrl.contact.isCompany = contact.isCompany;
                ctrl.contact.name = contact.isCompany
                  ? contact.company.information.name
                  : contact.person.information.firstName;
                ctrl.contact.familyName = contact.person.information.familyName;
                ctrl.contact.phoneCode = contact.isCompany
                  ? contact.company.contact.phoneCode
                  : contact.person.contact.primaryCode;
                ctrl.contact.phone = contact.isCompany
                  ? contact.company.contact.phone
                  : contact.person.contact.primary;
                ctrl.contact.email = contact.isCompany
                  ? contact.company.contact.email
                  : contact.person.contact.email;
                ctrl.contact.homeCode = contact.isCompany
                  ? ''
                  : contact.person.contact.homeCode;
                ctrl.contact.home = contact.isCompany ? '' : contact.person.contact.home;
                ctrl.contact.workCode = contact.isCompany
                  ? ''
                  : contact.person.contact.workCode;
                ctrl.contact.work = contact.isCompany ? '' : contact.person.contact.work;
                ctrl.contact.preferredContactMethod.phone = contact.isCompany
                  ? contact.company.contact.preferredContactMethod.phone
                  : contact.person.contact.preferredContactMethod.phone;
                ctrl.contact.preferredContactMethod.email = contact.isCompany
                  ? contact.company.contact.preferredContactMethod.email
                  : contact.person.contact.preferredContactMethod.email;
                if (ctrl.workflow.isAssetFinance() && !contact.isCompany) {
                  ctrl.contact.residentialStatus = contact.person.contact.housing;
                  if (contact.person.employments.length) {
                    ctrl.contact.employmentType = contact.person.employments[0].type;
                    ctrl.contact.employmentBasis = contact.person.employments[0].basis;
                    ctrl.contact.employmentSubTypes.onBenefits =
                      contact.person.employments[0].subTypes.onBenefits;
                    ctrl.contact.employmentSubTypes.student =
                      contact.person.employments[0].subTypes.student;
                    ctrl.contact.employmentSubTypes.homeDuties =
                      contact.person.employments[0].subTypes.homeDuties;
                  }
                }
                ctrl.updateContact(ctrl.contact);
              } else {
                ctrl.contact.name = '';
                uiService.toast({
                  text: { p1: 'WARNING', p2: 'Contact cannot be', p3: 'added twice' },
                  warn: true
                });
              }
            }
          });
        }
      };

      ctrl.searchContact = (query, isContactCompany) =>
        searchService.getContacts({ query, isCompany: isContactCompany });

      ctrl.getContactType = (contactType) => {
        const label = ctrl.ticketContactLabels.find((l) => l.id === contactType);
        return label;
      };

      ctrl.getIndex = (contact) => {
        const idx = ctrl.ticketContacts.indexOf(contact);
        return idx;
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
